export enum EUIAction {
  SET_DEVICE = 'SET_DEVICE',
  SET_COMMON_BRANCH = 'SET_COMMON_BRANCH',
  RESET_ACTION_STATUS = 'RESET_ACTION_STATUS',
}
